module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/slider/image4-d4c016ab62eb9cd1049c608ad4582f8d.jpg";